import {activeColors, borderRadius, fontsSize, shadows} from "./UIElements/Elements"
import {useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {faMugSaucer} from "@fortawesome/free-solid-svg-icons";

const TableButton = ({name, status, tableKey, setActiveCategoryId, tableFoodStatus}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (status === "FREE") {
            navigate("/order-dashboard");
        }
    };

    return (<div
        className={`text-white relative m-[0.5vw] ${fontsSize.m}
        max-lg:m-[1vw]
        w-[15.666vw] 
        h-[18vh]
        max-lg:w-[23vw]
        max-lg:h-[22.5vw]
        flex justify-center items-center ${shadows.sm}
             ${borderRadius.medium} ${status === "FREE" ? activeColors.success : activeColors.light} `}
        onClick={handleClick}>
        {name}
        {(status === "BUSY" || tableFoodStatus) &&
            <FontAwesomeIcon icon={faMugSaucer} className={`absolute right-3 bottom-3 text-[2vh]`}/>}

    </div>);
};


export default TableButton;